import { ComponentProps, ReactNode } from 'react';

import { cn } from '../lib';
import { Button, ButtonProps } from './button';
import { Link } from './link';
import { Typography } from './typography';

type ActionProps =
  | {
      as: 'button';
      label?: string;
      onClick?: () => void;
      buttonProps?: ButtonProps;
    }
  | { as: 'link'; label: string; to: string }
  | { as: 'custom'; render: ReactNode };

interface HeaderProps {
  className?: string;
  title: string;
  titleProps?: ComponentProps<typeof Typography>;
  action?: ActionProps;
}

export const Header = ({
  className,
  title,
  action,
  titleProps,
}: HeaderProps) => {
  const renderAction = () => {
    if (!action) return null;

    if (action.as === 'button') {
      return (
        <Button
          className="p-0 text-sm"
          variant="blue-link"
          onClick={action.onClick}
          {...action.buttonProps}
        >
          {action.label}
        </Button>
      );
    } else if (action.as === 'link') {
      return <Link to={action.to}>{action.label}</Link>;
    }

    return action.render;
  };

  return (
    <div className={cn('flex w-full items-center justify-between', className)}>
      <Typography variant="14-m" color="text-base-100" {...titleProps}>
        {title}
      </Typography>

      {renderAction()}
    </div>
  );
};
